import type { ReactNode } from 'react';
import { Modal, ModalActions, ModalNote } from '../Modal/Modal';
import { Button } from '../Button/Button';
import React from 'react';

export interface ConfirmModalProps {
    open: boolean;
    title: string;
    description?: ReactNode;
    confirmLabel?: string;
    cancelLabel?: string;
    danger?: boolean;
    busy?: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

export function ConfirmModal({
    open,
    title,
    description,
    confirmLabel = 'Подтвердить',
    cancelLabel = 'Отмена',
    danger = false,
    busy = false,
    onConfirm,
    onClose,
}: ConfirmModalProps) {
    if (!open) return null;

    return (
        <Modal
            open
            onClose={onClose}
            width={440}
            tone={danger ? 'danger' : 'accent'}
            title={title}
            footer={
                <>
                    {description ? <ModalNote>{description}</ModalNote> : null}
                    <ModalActions>
                        <Button onClick={onClose} disabled={busy}>
                            {cancelLabel}
                        </Button>
                        <Button variant="primary" onClick={onConfirm} disabled={busy}>
                            {confirmLabel}
                        </Button>
                    </ModalActions>
                </>
            }
        />
    );
}